import {
  Box,
  Card,
  Stack,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { JobCardStyles } from "../Styles";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

const JobCard = ({ jobTitle, location, share, copyLink }) => {
  return (
    <Card sx={JobCardStyles.JobCardMainContainer}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography variant="h6" sx={JobCardStyles.JobTypeTitlTxt}>
            {jobTitle}
          </Typography>
          <Box display="flex" alignItems="center" mt={0.5}>
            <Box sx={JobCardStyles.JobLocationLabelTxt}>LOCATION:</Box>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={JobCardStyles.JobLocationValueTxt}
            >
              {location}
            </Typography>
          </Box>
        </Box>
        <IconButton>
          <BookmarkBorderIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box mt={3}>
        <Typography
          gutterBottom
          variant="body2"
          fontWeight={500}
          color="text.secondary"
          sx={JobCardStyles.ShareJobTxt}
        >
          {share}
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center">
          <Button
            variant="contained"
            startIcon={<ContentCopyIcon />}
            sx={JobCardStyles.CopyLinkBtnTxt}
          >
            {copyLink}
          </Button>

          <IconButton
            sx={{
              backgroundColor: "#F0F4FF",
              "&:hover": { backgroundColor: "#e0e8fc" },
            }}
          >
            <LinkedInIcon sx={{ color: "#1A73E8" }} />
          </IconButton>

          <IconButton
            sx={{
              backgroundColor: "#F0F4FF",
              "&:hover": { backgroundColor: "#e0e8fc" },
            }}
          >
            <EmailIcon sx={{ color: "#1A73E8" }} />
          </IconButton>
        </Stack>
      </Box>

      <Button fullWidth sx={JobCardStyles.ApplyNowButton}>
        Apply Now
      </Button>
    </Card>
  );
};

export default JobCard;
